module.exports = __webpack_public_path__ + "static/media/MOF_hero.44f8b704.png";